/**
 * Utilitários para contagem de caracteres em conteúdo HTML (ignorando tags).
 * Usado por SummernoteEditor (limite de caracteres) e exibição de contadores.
 */

/**
 * Remove tags HTML e retorna apenas o texto visível (decodifica entidades quando possível).
 * @param {string} html - String possivelmente com HTML
 * @returns {string} Texto puro
 */
export function stripHtmlToText(html) {
    if (!html || typeof html !== 'string') return '';
    if (typeof document === 'undefined') {
      return html.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
    }
    const div = document.createElement('div');
    div.innerHTML = html;
    return (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim();
  }
  
  /**
   * Retorna a quantidade de caracteres do texto visível (ignorando tags HTML).
   * @param {string} html - String possivelmente com HTML
   * @returns {number}
   */
  export function getTextLength(html) {
    return stripHtmlToText(html).length;
  }